import React    from 'react';
import {Result, Button}    from 'antd';
import * as Sentry from "@sentry/react";

class ErrorBoundary extends React.Component {
    props: any
    constructor(props : any) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error: any, info: any) {
        console.error(error, info)
        process.env.REACT_APP_SENTRY_DSN && Sentry.captureMessage(error, info);
        this.setState({ hasError: true });
    }

    render() {
        //@ts-ignore
        if (this.state.hasError) {
            return <Result
                status="500"
                title="500"
                subTitle="Sorry, something went wrong."
                extra={<Button type="primary" onClick={() => window.location.pathname = "/"}>Back</Button>}
            />
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
